/**
 * Tencent is pleased to support the open source community by making outerdata-opensouce available.
 * Copyright (C) 2019 Limited, Tencent company. All rights reserved.
 * Licensed under the MIT License (the "License"); you may not use this file except in compliance
 * with the License. You may obtain a copy of the License at
 * http://opensource.org/licenses/MIT
 * Unless required by applicable law or agreed to in writing, software distributed under the License is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line camelcase
import legendEn from '@/lang/en/legend_en.js'
export const legend = legendEn

export const common = {
    Domestic: 'China',
    Overseas: 'World',
    Non_Hubei: 'Non-Hubei',
    Region: 'Region',
    GRegion: 'Country/Region',
    Macau: 'Macau',

    Active_Cases: 'Active Cases',
    Suspected_Cases: 'Suspected Cases',
    Severe_Cases: 'Severe Cases',
    Imported_Cases: 'Imported Cases',
    New_Cases: 'New Cases',
    Total_Cases: 'Total Cases',
    Total_Recovered: 'Total Recovered',
    Total_Deaths: 'Total Deaths',

    Data_Explanations: 'Data Explanations',
    New: 'New',
    More: 'More',
    Show_Less: 'Show Less',
    Close: 'Close',

    covidmap: 'COVID-19 Map',
    coviddata: 'World Updates',
    China_Updates: 'China Updates',

    time: 'Update',
    updating: 'Updating'
}

export const home = {
    COVID_19_Map: 'COVID-19 Map',
    Regional_Updates: 'Regional Updates',
    Overseas_Updates: 'World Updates',
    Live_Updates: 'Live Updates',
    D_Live_Updates: 'Domestic Live Updates',
    O_Live_Updates: 'Overseas Live Updates'
}

export const details = {
    COVID_19_Live_Updates: 'COVID-19 Live Updates',
    COVID_19_Map: 'COVID-19 Map',
    Regional_Updates: 'Regional Updates',
    End: 'End'
}

export const url = {
    header_bg_logo: 'https://static.wecity.qq.com/h5/2020-3/herder_bg_logo_en-5851e2fd18f11c05b3c769d66ad962fa.jpg',
    header_bg_empty: 'https://static.wecity.qq.com/h5/2020-3/header_bg_empty_en-fdf5c994749c1eaa4ef6e432e8de4195.png'
}

export const currentProvData = {
    Afghanistan: 'Afghanistan',
    Albania: 'Albania',
    Algeria: 'Algeria',
    Andorra: 'Andorra',
    Angola: 'Angola',
    Antarctica: 'Antarctica',
    'Antigua and Barbuda': 'Antigua and Barbuda',
    Argentina: 'Argentina',
    Armenia: 'Armenia',
    Australia: 'Australia',
    Austria: 'Austria',
    Azerbaijan: 'Azerbaijan',
    'The Bahamas': 'The Bahamas',
    Bahrain: 'Bahrain',
    Bangladesh: 'Bangladesh',
    Barbados: 'Barbados',
    Belarus: 'Belarus',
    Belgium: 'Belgium',
    Belize: 'Belize',
    Benin: 'Benin',
    Bermuda: 'Bermuda',
    Bhutan: 'Bhutan',
    Bolivia: 'Bolivia',
    'Bosnia and Herzegovina': 'Bosnia and Herzegovina',
    Botswana: 'Botswana',
    Brazil: 'Brazil',
    Brunei: 'Brunei',
    Bulgaria: 'Bulgaria',
    'Burkina Faso': 'Burkina Faso',
    Burundi: 'Burundi',
    Cambodia: 'Cambodia',
    Cameroon: 'Cameroon',
    Canada: 'Canada',
    'Cape Verde': 'Cape Verde',
    'Central African Republic': 'Central African Republic',
    Chad: 'Chad',
    Chile: 'Chile',
    China: 'China',
    Colombia: 'Colombia',
    Comoros: 'Comoros',
    'Republic of the Congo': 'Republic of the Congo',
    'Costa Rica': 'Costa Rica',
    Croatia: 'Croatia',
    Cuba: 'Cuba',
    Cyprus: 'Cyprus',
    'Czech Republic': 'Czech Republic',
    Denmark: 'Denmark',
    Djibouti: 'Djibouti',
    Dominica: 'Dominica',
    'Dominican Republic': 'Dominican Republic',
    Ecuador: 'Ecuador',
    Egypt: 'Egypt',
    'El Salvador': 'El Salvador',
    'Equatorial Guinea': 'Equatorial Guinea',
    Eritrea: 'Eritrea',
    Estonia: 'Estonia',
    Ethiopia: 'Ethiopia',
    'Falkland Islands': 'Falkland Islands',
    'Faroe Islands': 'Faroe Islands',
    Fiji: 'Fiji',
    Finland: 'Finland',
    France: 'France',
    'French Guiana': 'French Guiana',
    'French Southern and Antarctic Lands': 'French Southern and Antarctic Lands',
    Gabon: 'Gabon',
    Gambia: 'Gambia',
    'Gaza Strip': 'Gaza Strip',
    Georgia: 'Georgia',
    Germany: 'Germany',
    Ghana: 'Ghana',
    Greece: 'Greece',
    Greenland: 'Greenland',
    Grenada: 'Grenada',
    Guadeloupe: 'Guadeloupe',
    Guatemala: 'Guatemala',
    Guinea: 'Guinea',
    'Guinea Bissau': 'Guinea Bissau',
    Guyana: 'Guyana',
    Haiti: 'Haiti',
    Honduras: 'Honduras',
    'Hong Kong': 'Hong Kong',
    Hungary: 'Hungary',
    Iceland: 'Iceland',
    India: 'India',
    Indonesia: 'Indonesia',
    Iran: 'Iran',
    Iraq: 'Iraq',
    'Iraq-Saudi Arabia Neutral Zone': 'Iraq-Saudi Arabia Neutral Zone',
    Ireland: 'Ireland',
    'Isle of Man': 'Isle of Man',
    Israel: 'Israel',
    Italy: 'Italy',
    'Ivory Coast': 'Ivory Coast',
    Jamaica: 'Jamaica',
    'Jan Mayen': 'Jan Mayen',
    Japan: 'Japan',
    Jordan: 'Jordan',
    Kazakhstan: 'Kazakhstan',
    Kenya: 'Kenya',
    Kerguelen: 'Kerguelen',
    Kiribati: 'Kiribati',
    'North Korea': 'North Korea',
    'South Korea': 'South Korea',
    Kuwait: 'Kuwait',
    Kyrgyzstan: 'Kyrgyzstan',
    Laos: 'Laos',
    Latvia: 'Latvia',
    Lebanon: 'Lebanon',
    Lesotho: 'Lesotho',
    Liberia: 'Liberia',
    Libya: 'Libya',
    Liechtenstein: 'Liechtenstein',
    Lithuania: 'Lithuania',
    Luxembourg: 'Luxembourg',
    Macau: 'Macau',
    Macedonia: 'Macedonia',
    Madagascar: 'Madagascar',
    Malawi: 'Malawi',
    Malaysia: 'Malaysia',
    Maldives: 'Maldives',
    Mali: 'Mali',
    Malta: 'Malta',
    Martinique: 'Martinique',
    Mauritania: 'Mauritania',
    Mauritius: 'Mauritius',
    Mexico: 'Mexico',
    Moldova: 'Moldova',
    Monaco: 'Monaco',
    Mongolia: 'Mongolia',
    Morocco: 'Morocco',
    Mozambique: 'Mozambique',
    Myanmar: 'Myanmar',
    Namibia: 'Namibia',
    Nepal: 'Nepal',
    Netherlands: 'Netherlands',
    'New Caledonia': 'New Caledonia',
    'New Zealand': 'New Zealand',
    Nicaragua: 'Nicaragua',
    Niger: 'Niger',
    Nigeria: 'Nigeria',
    'Northern Mariana Islands': 'Northern Mariana Islands',
    Norway: 'Norway',
    Oman: 'Oman',
    Pakistan: 'Pakistan',
    Panama: 'Panama',
    'Papua New Guinea': 'Papua New Guinea',
    Paraguay: 'Paraguay',
    Peru: 'Peru',
    Philippines: 'Philippines',
    Poland: 'Poland',
    Portugal: 'Portugal',
    'Puerto Rico': 'Puerto Rico',
    Qatar: 'Qatar',
    Reunion: 'Reunion',
    Romania: 'Romania',
    Russia: 'Russia',
    Rwanda: 'Rwanda',
    'San Marino': 'San Marino',
    'Sao Tome and Principe': 'Sao Tome and Principe',
    'Saudi Arabia': 'Saudi Arabia',
    Senegal: 'Senegal',
    Seychelles: 'Seychelles',
    'Sierra Leone': 'Sierra Leone',
    Singapore: 'Singapore',
    Slovakia: 'Slovakia',
    Slovenia: 'Slovenia',
    'Solomon Islands': 'Solomon Islands',
    Somalia: 'Somalia',
    'South Africa': 'South Africa',
    Spain: 'Spain',
    'Sri Lanka': 'Sri Lanka',
    'St. Christopher-Nevis': 'St. Christopher-Nevis',
    'St. Lucia': 'St. Lucia',
    'St. Vincent and the Grenadines': 'St. Vincent and the Grenadines',
    Sudan: 'Sudan',
    Suriname: 'Suriname',
    Svalbard: 'Svalbard',
    Swaziland: 'Swaziland',
    Sweden: 'Sweden',
    Switzerland: 'Switzerland',
    Syria: 'Syria',
    Taiwan: 'Taiwan',
    Tajikistan: 'Tajikistan',
    'United Republic of Tanzania': 'United Republic of Tanzania',
    Thailand: 'Thailand',
    Togo: 'Togo',
    Tonga: 'Tonga',
    'Trinidad and Tobago': 'Trinidad and Tobago',
    Tunisia: 'Tunisia',
    Turkey: 'Turkey',
    Turkmenistan: 'Turkmenistan',
    'Turks and Caicos Islands': 'Turks and Caicos Islands',
    Uganda: 'Uganda',
    Ukraine: 'Ukraine',
    'United Arab Emirates': 'United Arab Emirates',
    'United Kingdom': 'United Kingdom',
    'United States of America': 'United States of America',
    Uruguay: 'Uruguay',
    Uzbekistan: 'Uzbekistan',
    Vanuatu: 'Vanuatu',
    Venezuela: 'Venezuela',
    Vatican: 'Vatican',
    Vietnam: 'Vietnam',
    'Western Sahara': 'Western Sahara',
    'Western Samoa': 'Western Samoa',
    Yemen: 'Yemen',
    Yugoslavia: 'Yugoslavia',
    'Democratic Republic of the Congo': 'Democratic Republic of the Congo',
    Zambia: 'Zambia',
    Zimbabwe: 'Zimbabwe',
    'South Sudan': 'South Sudan',
    Somaliland: 'Somaliland',
    Montenegro: 'Montenegro',
    Kosovo: 'Kosovo',
    'Republic of Serbia': 'Republic of Serbia',
    'East Timor': 'East Timor'
}
